/* NTS quote basket — vanilla JS, no deps. Persists guest/B2B quote selections
   in localStorage so a customer can build up multiple line items before
   submitting one consolidated quote request. */
(function () {
  'use strict';

  var STORAGE_KEY = 'nts_quote_basket';
  var STATUS_TIMEOUT_MS = 3000;
  // Fallback mapping for non-English Shopify display variants that may exist
  // in customer.default_address.country from accounts originally created via
  // the old localized country picker on /pages/apply. Direct opt.value (ISO-2)
  // and opt.textContent (English label) matches are tried first; this table
  // only fires when neither hits.
  var COUNTRY_NAME_TO_ISO2 = {
    'Deutschland': 'DE',
    'Danmark': 'DK',
    'Österreich': 'AT',
    'België / Belgique': 'BE',
    'België': 'BE',
    'Belgique': 'BE',
    'Česká republika': 'CZ',
    'Eesti': 'EE',
    'Ελλάδα (Greece)': 'EL',
    'Ελλάδα': 'EL',
    'España': 'ES',
    'Suomi': 'FI',
    'Hrvatska': 'HR',
    'Magyarország': 'HU',
    'Italia': 'IT',
    'Lietuva': 'LT',
    'Latvija': 'LV',
    'Nederland': 'NL',
    'Norge': 'NO',
    'Polska': 'PL',
    'România': 'RO',
    'Sverige': 'SE',
    'Slovenija': 'SI',
    'Slovensko': 'SK',
    'Schweiz': 'CH'
  };
  var listeners = [];

  function emptyBasket() {
    return { items: [], updated_at: new Date().toISOString() };
  }

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return emptyBasket();
      var parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.items)) return emptyBasket();
      return parsed;
    } catch (e) {
      return emptyBasket();
    }
  }

  function write(basket) {
    basket.updated_at = new Date().toISOString();
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(basket));
    } catch (e) {
      // localStorage full or disabled — silently ignore; UI still updates in-session.
    }
    listeners.forEach(function (cb) {
      try { cb(basket); } catch (e) { /* swallow */ }
    });
    return basket;
  }

  function sameLine(item, sku, variantId) {
    return String(item.sku) === String(sku) && String(item.variant_id) === String(variantId);
  }

  function getItems() {
    return read().items.slice();
  }

  function getCount() {
    return read().items.reduce(function (sum, it) {
      return sum + (Number(it.quantity) || 0);
    }, 0);
  }

  function getItemCount() {
    return read().items.length;
  }

  function add(payload) {
    if (!payload || !payload.sku) return read();
    var basket = read();
    var qty = Number(payload.quantity) || 1;
    var existing = basket.items.find(function (it) {
      return sameLine(it, payload.sku, payload.variant_id);
    });
    if (existing) {
      existing.quantity = (Number(existing.quantity) || 0) + qty;
    } else {
      basket.items.push({
        sku: payload.sku,
        title: payload.title || '',
        handle: payload.handle || '',
        variant_id: payload.variant_id || '',
        quantity: qty,
        image_url: payload.image_url || '',
        added_at: new Date().toISOString()
      });
    }
    return write(basket);
  }

  function updateQuantity(sku, variantId, qty) {
    var basket = read();
    var n = Number(qty) || 0;
    if (n <= 0) return remove(sku, variantId);
    basket.items = basket.items.map(function (it) {
      if (sameLine(it, sku, variantId)) {
        it.quantity = n;
      }
      return it;
    });
    return write(basket);
  }

  function remove(sku, variantId) {
    var basket = read();
    basket.items = basket.items.filter(function (it) {
      return !sameLine(it, sku, variantId);
    });
    return write(basket);
  }

  function clear() {
    return write(emptyBasket());
  }

  function onChange(cb) {
    if (typeof cb === 'function') listeners.push(cb);
  }

  function refreshBadges() {
    var count = getCount();
    var nodes = document.querySelectorAll('.nts-basket-count');
    nodes.forEach(function (node) {
      node.textContent = String(count);
      // Header badge specifically hides when empty; in-button counters stay.
      if (node.closest('.nts-header-quote-link')) {
        if (count === 0) {
          node.classList.add('nts-basket-count-empty');
        } else {
          node.classList.remove('nts-basket-count-empty');
        }
      }
    });
  }

  function showStatus(text) {
    var status = document.getElementById('nts-quote-status');
    if (!status) return;
    status.textContent = text;
    if (status._ntsTimer) clearTimeout(status._ntsTimer);
    status._ntsTimer = setTimeout(function () {
      status.textContent = '';
    }, STATUS_TIMEOUT_MS);
  }

  function wireAddButton() {
    var btn = document.getElementById('nts-add-to-quote-btn');
    if (!btn) return;
    var block = btn.closest('.nts-quote-request-block');
    if (!block) return;
    btn.addEventListener('click', function () {
      var payload = {
        sku: block.getAttribute('data-product-sku') || '',
        title: block.getAttribute('data-product-title') || '',
        handle: block.getAttribute('data-product-handle') || '',
        variant_id: block.getAttribute('data-variant-id') || '',
        image_url: block.getAttribute('data-image-url') || '',
        quantity: 1
      };
      if (!payload.sku) {
        showStatus('Cannot add: missing SKU.');
        return;
      }
      var basket = add(payload);
      var count = basket.items.reduce(function (s, it) { return s + (Number(it.quantity) || 0); }, 0);
      showStatus('Added to quote (' + count + ' item' + (count === 1 ? '' : 's') + ')');
    });
  }

  /* ---------- Quote-request page (Phase 5) ---------- */

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var qtyDebounceTimers = {};

  function isValidEmail(s) {
    return EMAIL_RE.test(String(s || '').trim());
  }

  function snapshotItems(items) {
    return items.map(function (it) {
      return [it.sku, it.variant_id || '', it.quantity, it.title || '', it.handle || '', it.image_url || ''].join('|');
    }).join('||');
  }

  function appendCell(row, className, child) {
    var cell = document.createElement('div');
    cell.className = 'nts-quote-basket-cell ' + className;
    if (child) cell.appendChild(child);
    row.appendChild(cell);
    return cell;
  }

  function buildBasketRow(item) {
    var row = document.createElement('div');
    row.className = 'nts-quote-basket-row';
    row.setAttribute('data-sku', item.sku);
    row.setAttribute('data-variant-id', item.variant_id || '');

    // Image
    var imgWrap = document.createElement('div');
    imgWrap.className = 'nts-quote-basket-thumb';
    if (item.image_url) {
      var img = document.createElement('img');
      img.src = item.image_url;
      img.alt = item.title ? item.title : item.sku;
      img.loading = 'lazy';
      imgWrap.appendChild(img);
    }
    appendCell(row, 'nts-quote-basket-image-cell', imgWrap);

    // Product (title + SKU)
    var prodWrap = document.createElement('div');
    var titleEl;
    if (item.handle) {
      titleEl = document.createElement('a');
      titleEl.href = '/products/' + encodeURIComponent(item.handle);
    } else {
      titleEl = document.createElement('span');
    }
    titleEl.className = 'nts-quote-basket-title';
    titleEl.textContent = item.title || '(untitled product)';
    prodWrap.appendChild(titleEl);
    if (item.sku) {
      var skuEl = document.createElement('div');
      skuEl.className = 'nts-quote-basket-sku';
      skuEl.textContent = 'SKU: ' + item.sku;
      prodWrap.appendChild(skuEl);
    }
    appendCell(row, 'nts-quote-basket-product-cell', prodWrap);

    // Quantity
    var qtyWrap = document.createElement('div');
    var qtyId = 'nts-qty-' + String(item.sku).replace(/[^a-z0-9]/gi, '-') + '-' + String(item.variant_id || '0');
    var qtyLabel = document.createElement('label');
    qtyLabel.className = 'visually-hidden';
    qtyLabel.setAttribute('for', qtyId);
    qtyLabel.textContent = 'Quantity for ' + (item.title || item.sku);
    var qtyInput = document.createElement('input');
    qtyInput.type = 'number';
    qtyInput.id = qtyId;
    qtyInput.min = '1';
    qtyInput.step = '1';
    qtyInput.value = String(item.quantity);
    qtyInput.className = 'nts-form-input nts-quote-basket-qty-input';
    qtyInput.setAttribute('data-sku', item.sku);
    qtyInput.setAttribute('data-variant-id', item.variant_id || '');
    qtyInput.setAttribute('inputmode', 'numeric');
    qtyWrap.appendChild(qtyLabel);
    qtyWrap.appendChild(qtyInput);
    appendCell(row, 'nts-quote-basket-qty-cell', qtyWrap);

    // Remove
    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'nts-quote-basket-remove-btn';
    removeBtn.setAttribute('data-sku', item.sku);
    removeBtn.setAttribute('data-variant-id', item.variant_id || '');
    removeBtn.setAttribute('aria-label', 'Remove ' + (item.title || item.sku) + ' from quote');
    removeBtn.textContent = 'Remove';
    appendCell(row, 'nts-quote-basket-remove-cell', removeBtn);

    return row;
  }

  function buildEmptyState() {
    var wrap = document.createElement('div');
    wrap.className = 'nts-quote-empty-state';
    var msg = document.createElement('p');
    msg.textContent = 'Your quote basket is empty.';
    wrap.appendChild(msg);
    var link = document.createElement('a');
    link.href = '/collections';
    link.className = 'nts-btn nts-btn-secondary';
    link.textContent = 'Browse products';
    wrap.appendChild(link);
    return wrap;
  }

  function onQtyInput(e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('nts-quote-basket-qty-input')) return;
    var sku = input.getAttribute('data-sku');
    var variantId = input.getAttribute('data-variant-id') || '';
    var key = sku + '|' + variantId;
    if (qtyDebounceTimers[key]) clearTimeout(qtyDebounceTimers[key]);
    qtyDebounceTimers[key] = setTimeout(function () {
      var n = parseInt(input.value, 10);
      if (isNaN(n) || n < 1) n = 1;
      updateQuantity(sku, variantId, n);
    }, 500);
  }

  function onRemoveClick(e) {
    var btn = e.target.closest && e.target.closest('.nts-quote-basket-remove-btn');
    if (!btn) return;
    remove(btn.getAttribute('data-sku'), btn.getAttribute('data-variant-id') || '');
  }

  function renderBasketTable(root) {
    if (!root) return;
    var items = getItems();
    var snap = snapshotItems(items);
    if (root._ntsLastSnapshot === snap) return;

    // Preserve focus + caret across rebuild (covers in-tab quantity edits).
    var focusKey = null;
    var caretPos = 0;
    var active = document.activeElement;
    if (active && active.classList && active.classList.contains('nts-quote-basket-qty-input')) {
      focusKey = active.getAttribute('data-sku') + '|' + (active.getAttribute('data-variant-id') || '');
      try { caretPos = active.selectionStart || 0; } catch (e) { /* ignore */ }
    }

    while (root.firstChild) root.removeChild(root.firstChild);

    if (items.length === 0) {
      root.appendChild(buildEmptyState());
      root._ntsLastSnapshot = snap;
      return;
    }

    var header = document.createElement('div');
    header.className = 'nts-quote-basket-row nts-quote-basket-header';
    ['', 'Product', 'Quantity', ''].forEach(function (label) {
      var cell = document.createElement('div');
      cell.className = 'nts-quote-basket-cell';
      cell.textContent = label;
      header.appendChild(cell);
    });
    root.appendChild(header);

    items.forEach(function (item) {
      root.appendChild(buildBasketRow(item));
    });

    var footer = document.createElement('div');
    footer.className = 'nts-quote-basket-footer';
    var totalCount = getCount();
    footer.textContent = totalCount + ' item' + (totalCount === 1 ? '' : 's') + ' in basket — quote required for total';
    root.appendChild(footer);

    root._ntsLastSnapshot = snap;

    // Restore focus
    if (focusKey) {
      var inputs = root.querySelectorAll('.nts-quote-basket-qty-input');
      for (var i = 0; i < inputs.length; i++) {
        var k = inputs[i].getAttribute('data-sku') + '|' + (inputs[i].getAttribute('data-variant-id') || '');
        if (k === focusKey) {
          inputs[i].focus();
          try { inputs[i].setSelectionRange(caretPos, caretPos); } catch (e) { /* ignore */ }
          break;
        }
      }
    }
  }

  function showFieldError(input, msg) {
    if (!input) return;
    input.setAttribute('aria-invalid', 'true');
    var errId = input.getAttribute('aria-describedby');
    if (!errId) return;
    var errEl = document.getElementById(errId);
    if (errEl) errEl.textContent = msg;
  }

  function clearFieldError(input) {
    if (!input) return;
    input.setAttribute('aria-invalid', 'false');
    var errId = input.getAttribute('aria-describedby');
    if (!errId) return;
    var errEl = document.getElementById(errId);
    if (errEl) errEl.textContent = '';
  }

  function validateField(input) {
    if (!input) return true;
    var value = String(input.value || '').trim();
    if (input.getAttribute('data-required') === 'true' && !value) {
      showFieldError(input, 'This field is required.');
      return false;
    }
    if (input.getAttribute('data-validate') === 'email' && value && !isValidEmail(value)) {
      showFieldError(input, 'Please enter a valid email address.');
      return false;
    }
    clearFieldError(input);
    return true;
  }

  function updateSubmitState(form) {
    if (!form) return;
    var btn = form.querySelector('[data-quote-submit]');
    if (!btn) return;
    var hasItems = getCount() > 0;
    var allFilled = true;
    var requiredInputs = form.querySelectorAll('[data-required="true"]');
    for (var i = 0; i < requiredInputs.length; i++) {
      if (!String(requiredInputs[i].value || '').trim()) {
        allFilled = false;
        break;
      }
    }
    btn.disabled = !(hasItems && allFilled);
  }

  function readFormValue(form, name) {
    var el = form.querySelector('[name="' + name + '"]');
    return el ? String(el.value || '').trim() : '';
  }

  var MIDDLEWARE_BASE = 'https://nts-integration-middleware-production.up.railway.app';

  // reCAPTCHA v3 token fetch. Resolves to a token string, or empty string on
  // any failure (no site key, library missing, .execute() rejection / throw).
  // The server's strict-block contract rejects empty tokens with a generic 400,
  // so the failure-to-empty path correctly surfaces as "Could not submit" UX.
  function getRecaptchaToken() {
    return new Promise(function (resolve) {
      var page = document.querySelector('quote-request-page');
      var siteKey = page ? (page.getAttribute('data-recaptcha-site-key') || '') : '';

      // Site key not configured in theme settings → fall through to empty token.
      if (!siteKey) {
        resolve('');
        return;
      }

      // grecaptcha library failed to load (privacy extension, ad blocker, network).
      if (typeof window.grecaptcha === 'undefined' || typeof window.grecaptcha.ready !== 'function') {
        resolve('');
        return;
      }

      try {
        // grecaptcha.ready() guarantees the library finished bootstrapping
        // before we call execute(). Token is fetched here at submit time, NOT
        // at page load — v3 tokens expire after ~2 minutes and a user filling
        // a long form would otherwise hit verification_failed server-side.
        window.grecaptcha.ready(function () {
          try {
            window.grecaptcha.execute(siteKey, { action: 'quote_request' })
              .then(function (token) { resolve(token || ''); })
              .catch(function (err) {
                if (window.console && console.warn) console.warn('[nts-quote] grecaptcha.execute rejected:', err);
                resolve('');
              });
          } catch (e) {
            if (window.console && console.warn) console.warn('[nts-quote] grecaptcha.execute threw:', e);
            resolve('');
          }
        });
      } catch (e) {
        if (window.console && console.warn) console.warn('[nts-quote] grecaptcha.ready threw:', e);
        resolve('');
      }
    });
  }

  function submitQuoteRequest(form) {
    if (!form) return;

    // Honeypot — bots fill it, real users don't see it.
    var honey = form.querySelector('[name="website_url"]');
    var honeyValue = honey ? String(honey.value || '').trim() : '';
    if (honeyValue) {
      showStatus('Could not submit. Please try again.');
      return;
    }

    // Validate every required field + email format
    var allValid = true;
    form.querySelectorAll('[data-required="true"]').forEach(function (input) {
      if (!validateField(input)) allValid = false;
    });
    var emailField = form.querySelector('[data-validate="email"]');
    if (emailField && !validateField(emailField)) allValid = false;
    if (!allValid) {
      showStatus('Please fix the highlighted fields.');
      return;
    }

    if (getCount() === 0) {
      showStatus('Your basket is empty.');
      return;
    }

    var renderTs = parseInt(readFormValue(form, 'render_timestamp'), 10) || 0;

    var payload = {
      contact: {
        first_name: readFormValue(form, 'first_name'),
        last_name: readFormValue(form, 'last_name'),
        email: readFormValue(form, 'email'),
        phone: readFormValue(form, 'phone')
      },
      company: {
        name: readFormValue(form, 'company_name'),
        country: readFormValue(form, 'country')
      },
      source: {
        is_logged_in: readFormValue(form, 'is_logged_in') === 'true'
      },
      message: readFormValue(form, 'customer_message'),
      items: getItems().map(function (it) {
        return {
          sku: it.sku,
          title: it.title,
          handle: it.handle,
          variant_id: it.variant_id,
          quantity: it.quantity,
          image_url: it.image_url
        };
      }),
      meta: {
        source_url: window.location.href,
        render_timestamp: renderTs,
        honeypot: honeyValue
      }
    };

    var submitBtn = form.querySelector('[data-quote-submit]');
    if (submitBtn) submitBtn.disabled = true;
    showStatus('Submitting...');

    // reCAPTCHA v3 — token fetched at submit time (v3 tokens expire after ~2min).
    // Empty token on any failure path is fine; server's strict-block contract
    // rejects with a generic 400 that surfaces in the existing error UI.
    getRecaptchaToken().then(function (recaptchaToken) {
      payload.recaptcha_token = recaptchaToken;
      return fetch(MIDDLEWARE_BASE + '/api/quote-request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
    }).then(function (res) {
      return res.json().catch(function () { return {}; }).then(function (data) {
        return { ok: res.ok, data: data };
      });
    }).then(function (result) {
      if (!result.ok || !result.data || !result.data.ok) {
        showStatus((result.data && result.data.error) || 'Could not submit. Please try again.');
        if (submitBtn) submitBtn.disabled = false;
        return;
      }
      // Success — clear basket and redirect to confirmation page.
      clear();
      var ref = result.data.reference || '';
      var targetUrl = '/pages/quote-confirmation' + (ref ? '?ref=' + encodeURIComponent(ref) : '');
      window.location.href = targetUrl;
    }).catch(function () {
      showStatus('Network error. Please check your connection and try again.');
      if (submitBtn) submitBtn.disabled = false;
    });
  }

  function bindFormHandlers(form) {
    if (!form) return;

    // Set the page-mount timestamp the server can use to gauge dwell time.
    var ts = form.querySelector('[data-render-timestamp]');
    if (ts) ts.value = String(Date.now());

    // Pre-select country from prefilled customer.default_address.country
    var countrySel = form.querySelector('select[name="country"]');
    if (countrySel) {
      var prefill = countrySel.getAttribute('data-prefill-country');
      if (prefill) {
        // 1) Direct match: opt.value (ISO-2) or opt.textContent (English label).
        var match = Array.prototype.find.call(countrySel.options, function (opt) {
          return opt.value === prefill || opt.textContent.trim() === prefill;
        });
        // 2) Fallback: known non-English variant → ISO-2 lookup → find by value.
        if (!match) {
          var iso = COUNTRY_NAME_TO_ISO2[prefill];
          if (iso) {
            match = Array.prototype.find.call(countrySel.options, function (opt) { return opt.value === iso; });
          }
        }
        if (match) countrySel.value = match.value;
      }
    }

    // Validation wiring
    form.querySelectorAll('[data-required="true"]').forEach(function (input) {
      input.addEventListener('blur', function () { validateField(input); });
      input.addEventListener('input', function () {
        clearFieldError(input);
        updateSubmitState(form);
      });
    });
    var emailField = form.querySelector('[data-validate="email"]');
    if (emailField) {
      emailField.addEventListener('blur', function () { validateField(emailField); });
    }

    // Submit
    var submitBtn = form.querySelector('[data-quote-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function () { submitQuoteRequest(form); });
    }

    updateSubmitState(form);
  }

  function initQuoteRequestPage() {
    var page = document.querySelector('quote-request-page');
    if (!page) return null;

    var basketRoot = page.querySelector('[data-quote-basket]');
    var form = page.querySelector('[data-quote-form]');

    if (basketRoot) {
      // Delegated listeners — attach once on the container, survive rebuilds.
      basketRoot.addEventListener('input', onQtyInput);
      basketRoot.addEventListener('click', onRemoveClick);
      renderBasketTable(basketRoot);
    }
    if (form) {
      bindFormHandlers(form);
    }

    // Re-render basket + refresh submit state on every basket mutation
    // (covers in-tab .add/.remove/.updateQuantity). Cross-tab is handled by
    // the existing 'storage' event listener below, which we extend to also
    // call renderBasketTable when the page is mounted.
    onChange(function () {
      if (basketRoot) renderBasketTable(basketRoot);
      if (form) updateSubmitState(form);
    });

    return { basketRoot: basketRoot, form: form };
  }

  // Public API
  window.NTSQuoteBasket = {
    getItems: getItems,
    getCount: getCount,
    getItemCount: getItemCount,
    add: add,
    updateQuantity: updateQuantity,
    remove: remove,
    clear: clear,
    onChange: onChange,
    STORAGE_KEY: STORAGE_KEY
  };

  // Auto-update badges whenever basket changes (covers programmatic .add/.remove too).
  onChange(refreshBadges);

  var pageMount = null;

  // Sync UI across tabs: another tab modifying the basket triggers a 'storage' event here.
  window.addEventListener('storage', function (e) {
    if (e.key !== STORAGE_KEY) return;
    refreshBadges();
    if (pageMount && pageMount.basketRoot) renderBasketTable(pageMount.basketRoot);
    if (pageMount && pageMount.form) updateSubmitState(pageMount.form);
  });

  function init() {
    refreshBadges();
    wireAddButton();
    pageMount = initQuoteRequestPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
